import VZSpinner from 'Components/VZSpinner';
import { getUrlFromAttributes } from 'Util/urlUtils';
import { showErrorModal } from 'Root/modal';

export default class VZSorting extends HTMLSelectElement {
    constructor() {
        super();
        this.excludedAttributes = ['class', 'data-configurator-type', 'data-url', 'data-general-error'];
    }

    connectedCallback() {
        this.addEventListener('change', this.onChange);
        this.spinner = document.querySelector('vz-spinner') || new VZSpinner();
    }

    onChange(evt) {
        const vZProductCard = this.closest('vz-product-card');
        const urlAttribute = evt.target.options[evt.target.selectedIndex].value;
        const url = getUrlFromAttributes(urlAttribute, vZProductCard, this.excludedAttributes);

        this.spinner.start();

        fetch(url)
            .then((res) => res.text())
            .then((response) => {
                this.closest('vz-product-card').dispatchEvent(new CustomEvent('variationChange', { detail: { response: response } }));
                document.getElementById('product-configurator').dispatchEvent(new CustomEvent('variationChange'));
                document.getElementById('product-configurator').dispatchEvent(new CustomEvent('pdp:sorting'));
            })
            .catch((e) => {
                console.log(e);
                const { title, body, cta } = JSON.parse(this.closest('vz-product-card').getAttribute('data-general-error'));
                showErrorModal(title, body, cta);
            })
            .finally(() => {
                this.spinner.stop();
            });
    }
}

if (!window.customElements.get('vz-sorting')) {
    window.customElements.define('vz-sorting', VZSorting, {
        extends: 'select'
    });
}
